import { Icon, IconProps } from '@elkaso-app/web-design';
import { BiTransfer } from 'react-icons/bi';

export const RestaurantTransfersIcons = (props: IconProps) => {
  return <Icon as={BiTransfer} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
